// src/components/store/sections/weekly-banner/WeeklyBannerV57BentopromoRoyalViolet.tsx
"use client";

import React from "react";
import DynamicWeeklyBannerVariant from "./DynamicWeeklyBannerVariant";

export default function WeeklyBannerV57BentopromoRoyalViolet(props: any) {
  return (
    <DynamicWeeklyBannerVariant
      variantNumber={57}
      archKey="bento_promo"
      archLabel="Bento Split Promo Grid"
      palName="RoyalViolet"
      grad="from-violet-600 via-purple-600 to-indigo-700"
      lightBg="bg-violet-50"
      textCol="text-violet-700"
      borderCol="border-violet-200"
      {...props}
    />
  );
}
